"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-nocheck

var v4_1 = __importDefault(require("uuid/v4"));

function initialState() {
  return {
    class: "transfer",
    type: null,
    subType: null,
    valueOwed: 0,
    transactions: [],
    // NOTE: summary: null, // compiled from payments descriptions
    to: null,
    from: null,
    additionalDescription: null,
    // Insiders
    benefit: false // did the insider benefit from payment/property transfer

  };
}

var createTransfer = function createTransfer(attrs) {
  return _objectSpread(_objectSpread(_objectSpread({}, initialState()), attrs), {}, {
    id: (0, v4_1.default)()
  });
};

exports.default = createTransfer;